module.exports = __webpack_public_path__ + "static/media/diktat-13.56d84ab9.mp3";